<div *ngIf="!init" style="align-self: center">
  <mat-spinner style="margin: auto" color="primary" diameter="48"></mat-spinner>
</div>

<div class="edit-project" *ngIf="init">
  <div class="outer-container" *ngIf="!!project && !!model">
    <div class="action-buttons">
      <button
        class="menu-button"
        (click)="deleteSubProject()"
        type="button"
        mat-button
        [disabled]="model.id == null || executed"
      >
        Verwijder
      </button>
    </div>

    <client-adjustment-header
      [type]="lowerCaseType"
      [title]="subProjectTitle"
      [projectContacts]="project.projectContacts"
      [requestContact]="model.subProjectContact"
      [extraCompanyContacts]="project.projectExtraCompanyContacts"
      [client]="client"
      [currentCreatedAt]="model.currentCreatedAt"
      [approved]="model.approved"
      [approvedRegistration]="model.approvedRegistration"
      [projectId]="project.id"
      [address]="baseProject.projectPlacement.address"
    >
    </client-adjustment-header>

    <internal-info [subProject]="model" (save)="save.emit(model)">
    </internal-info>

    <client-adjustment-summary
      [address]="baseProject.projectPlacement.address"
      [placementFloor]="baseProject.projectPlacement.placementFloor"
      [executionAssets]="latestExecutionAssets"
      [secondBoard]="baseProject.projectPlacement.secondBoard"
      [otherOrderPlacementInfo]="
        baseProject.projectPlacement.otherOrderPlacementInfo
      "
      [products]="project.products"
      [originalProjectId]="baseProject.id"
      [adjustment]="model"
      [form]="form"
      [executed]="executed"
    ></client-adjustment-summary>

    <div class="executed-container">
      <div class="executed__data-container">
        <client-adjustment-form
          [type]="lowerCaseType"
          [readOnly]="false"
          [isExecuted]="showExecutionInfo"
          [adjustment]="model"
          [project]="project"
          [products]="project.products"
          [address]="baseProject.projectPlacement.address"
          [placementFloor]="baseProject.projectPlacement.placementFloor"
          [projectId]="project.id"
          [projectContacts]="project.projectContacts"
          [offlineUpload]="false"
          [minDate]="minDate"
          (adjustmentOut)="this.adjustment = $event"
          (repoByInpress)="this.repoByInpress = $event"
          (save)="save.emit(model)"
        ></client-adjustment-form>
      </div>

      <div *ngIf="designAssets?.length > 0" class="executed__image-container">
        <img
          *ngIf="isImage(designAssets[0])"
          class="max-summary-width max-summary-height clickable"
          src="/api/assets/{{ designAssets[0].uuid }}"
          (click)="openDesignLightbox()"
        />
      </div>
    </div>

    <client-adjustment-execution-info
      *ngIf="client && showExecutionInfo"
      [products]="project.products"
      [adjustment]="model"
      [client]="client"
    ></client-adjustment-execution-info>

    <sign-info-wrapper
      [client]="client"
      [ipBoard]="ipBoard"
      [infoType]="'immo'"
    ></sign-info-wrapper>

    <sign-info-wrapper
      [client]="client"
      [ipBoard]="ipBoard"
      [infoType]="'graphical'"
    ></sign-info-wrapper>

    <sign-info-wrapper
      [client]="client"
      [ipBoard]="ipBoard"
      [infoType]="'atelier'"
    ></sign-info-wrapper>

    <sign-info-wrapper
      [client]="client"
      [ipBoard]="ipBoard"
      [infoType]="'installer'"
    ></sign-info-wrapper>

    <appointment-collapse
      *ngIf="
        projectHasIPBoards &&
        project.id != null &&
        !showExecutionInfo &&
        (model.projectPlacement?.appointment ||
          model.projectPlacement?.collectKey ||
          model.appointmentBlocksTourAssignment)
      "
      [project]="project"
      [subProject]="model"
      [subProjectTitle]="subProjectTitle"
      [client]="client"
      (save)="save.emit(model)"
    ></appointment-collapse>

    <execution-collapse
      *ngIf="projectHasIPBoards && project.id != null"
      [project]="project"
      [subProject]="model"
      [subProjectTitle]="subProjectTitle"
      [client]="client"
      (save)="save.emit(model)"
      [divergentPricesOnly]="divergentPricesOnly"
    ></execution-collapse>

    <ng-container
      *ngIf="
        model.type === SUB_PROJECT_TYPES.SOLDRENTED &&
        model.projectInvoices?.length > 0
      "
    >
      <sticker-facturation
        *ngFor="let invoice of model.projectInvoices"
        [projectId]="project.id"
        [subProject]="model"
        [product]="project.products[0]"
        [secondBoardPresent]="
          baseProject?.projectPlacement?.secondBoard != null
        "
        [invoice]="invoice"
        [numInvolvedCompanies]="numInvolvedCompanies"
        [displayCompanyName]="numInvolvedCompanies > 1"
      ></sticker-facturation>
    </ng-container>

    <divergent-price-collapse
      *ngIf="projectHasIPBoards"
      [baseProject]="baseProject"
      [subProject]="model"
      [project]="project"
      [collaborative]="project.collaborative"
      (save)="save.emit(model)"
      (divergentPricesChecked)="divergentPricesOnly = $event"
    ></divergent-price-collapse>

    <sign-info
      *ngIf="!client && soldRented?.signSticker"
      [signStickerDetail]="soldRented.signSticker"
      [type]="'immo'"
    ></sign-info>
  </div>

  <div
    class="admin-actions-container w-100 d-flex justify-content-between mb-4"
  >
    <div class="d-flex">
      <button
        *ngIf="model.type === 'Repo'"
        class="btn btn-hold mr-2"
        mat-flat-button
        (click)="archive()"
      >
        Annuleren/wissen
      </button>
    </div>

    <div class="d-flex justify-content-end">
      <button
        *ngIf="model.type !== 'Repo'"
        class="btn btn-print mr-2"
        mat-flat-button
        (click)="openPrintworkDialog()"
      >
        Printwerk nodig
      </button>

      <ng-container *ngIf="!openedFromAppointment">
        <div
          [matTooltip]="'De job staat on hold'"
          [matTooltipDisabled]="!model.onHold"
        >
          <button
            [disabled]="model.onHold"
            class="btn btn-hold mr-2"
            mat-flat-button
            (click)="openOnHoldDialog()"
          >
            On Hold
          </button>

          <button
            *ngIf="
              model.type !== 'Repo' &&
              (!model.needsDesign || model.designFinished)
            "
            class="btn btn-design mr-2"
            mat-flat-button
            (click)="openDesignDialog()"
          >
            Ontwerp Extern
          </button>
        </div>

        <div
          *ngIf="model.needsDesign && !model.designFinished"
          [matTooltip]="
            'De job staat on hold, ontwerp als klaar markeren is niet mogelijk'
          "
          [matTooltipDisabled]="!model.onHold"
        >
          <button
            [disabled]="model.onHold"
            class="btn btn-accept"
            (click)="setDesignFinished()"
            mat-flat-button
          >
            Ontwerp klaar
          </button>
        </div>

        <div
          *ngIf="!model.needsDesign || model.designFinished"
          [matTooltip]="
            model.onHold
              ? 'De job staat on hold, goedkeuren is niet mogelijk'
              : ''
          "
          [matTooltipDisabled]="!model.onHold"
        >
          <button
            *ngIf="!model.approved"
            [disabled]="model.onHold"
            class="btn btn-accept"
            (click)="handleApproveWithException(true)"
            mat-flat-button
          >
            Goedkeuren
          </button>

          <button
            *ngIf="model.approved"
            class="btn btn-unapprove"
            (click)="changeApproved(false)"
            mat-flat-button
          >
            Goedkeuren annuleren
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="loadBeforeClose" class="load-container">
  <mat-spinner style="margin: auto" color="primary" diameter="48"></mat-spinner>
</div>
